import React, { useEffect, useState } from "react";
import "./departmentPriceList.css";
import LeftArrow from "../../Assets/Icons/LeftArrow.png";
import RightArrow from "../../Assets/Icons/RightArrow.png";
import ExtraIcon from "../../Assets/Icons/ExtraIcon.png";
import NoData from "../../Assets/Icons/NoData.png";
import { useTranslation } from "react-i18next";
import { scrollToTop } from "../../modules/scrollToTop/scrollAction";
import { useDispatch, useSelector } from "react-redux";
import { getAllDepPrice } from "../../modules/department/departmentThunk";
import { resetGetDepPrice } from "../../modules/department/departmentSlice";
import ToastPopup from "../../widgets/Toast/toastPopup";

const PriceList = ({ currentPage, setCurrentPage, onItemClick, handleSearch }) => {
  const itemsPerPage = 10;
  const [totalPages, setTotalPages] = useState([]);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { getDepPriceSuccess, getDepPriceErr } = useSelector((state) => state.department);
  const selectedLanguage = useSelector((state) => state.language.language);
  const [searchInput, setSearchInput] = useState();
  const [priceList, setPriceList] = useState([]);

  const fetchGetDepPrice = (pageNumber, search = handleSearch) => {
    const page = pageNumber ?? currentPage ?? 1;
    const limit = itemsPerPage;
    const searchFields = selectedLanguage === "vietnam" ? "departmentName.vi,priceCode" : "departmentName.en,priceCode";
    dispatch(getAllDepPrice({ page, limit, search, searchFields }));
  };

  useEffect(() => {
    if (handleSearch != undefined) {
      fetchGetDepPrice(1, handleSearch);
    }
  }, [handleSearch]);

  useEffect(() => {
    fetchGetDepPrice();
  }, []);
  // useEffect(() => {
  //   fetchGetDepPrice();
  // }, [searchInput]);

  useEffect(() => {
    if (getDepPriceErr) {
      ToastPopup.error(getDepPriceErr);
    }
    if (getDepPriceSuccess && getDepPriceSuccess.status === "success") {
      setTotalPages(getDepPriceSuccess.data.totalPages);
      setCurrentPage(getDepPriceSuccess.data.currentPage);
      setPriceList(getDepPriceSuccess.data.prices);
    }
    dispatch(resetGetDepPrice());
  }, [getDepPriceSuccess, getDepPriceErr]);

  const handleClick = (pageNumber) => {
    dispatch(scrollToTop());
    fetchGetDepPrice(pageNumber);
  };

  const handlePrevNext = (direction) => {
    dispatch(scrollToTop());
    if (direction === "prev" && currentPage > 1) {
      fetchGetDepPrice(currentPage - 1);
    } else if (direction === "next" && currentPage < totalPages) {
      fetchGetDepPrice(currentPage + 1);
    }
  };

  const truncateText = (text) => {
    if (text.length > 100) {
      return text.slice(0, 100) + "...";
    }
    return text;
  };

  const renderPagination = () => {
    const pages = [];
    if (totalPages <= 4) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 2) {
        pages.push(1, 2, { type: "ellipsis" }, totalPages);
      } else if (currentPage >= totalPages - 1) {
        pages.push(1, { type: "ellipsis" }, totalPages - 1, totalPages);
      } else {
        pages.push(1, { type: "ellipsis" }, currentPage, { type: "ellipsis" }, totalPages);
      }
    }
    return pages;
  };

  return (
    <div className="dp-secondary-box">
      <div className="dp-price-box">
        <table className="dp-price-layout">
          <thead className="dp-thead">
            <tr>
              <th>{t("code")}</th>
              <th>{t("department")}</th>
              <th>{t("durationInMins")}</th>
              <th>Grade</th>
              <th>OPD International Insured</th>
              <th>OPD Local Insured</th>
              <th>OPD Subsidized</th>
            </tr>
          </thead>
          <tbody className="dp-tbody">
            {priceList.map((item, index) => (
              <tr key={index} className="dp-table-row" onClick={() => onItemClick(item)}>
                <td>{item.priceCode}</td>
                <td>{selectedLanguage === "vietnam" ? truncateText(item.departmentName.vi) : truncateText(item.departmentName.en)}</td>
                <td>{item.duration}</td>
                <td>{item.grade}</td>
                <td>{item.price?.opdInternational ? `₫ ${item.price.opdInternational.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` : ""}</td>
                <td>{item.price?.opdLocalPrice ? `₫ ${item.price?.opdLocalPrice.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` : ""}</td>
                <td>{item.price?.opdSubsidized ? `₫ ${item.price?.opdSubsidized.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}` : t("create")}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {totalPages === 0 && (
          <div className="no-record-container">
            <div className="no-record-icon">
              <img src={NoData} alt="No Data Found" />
            </div>
            <div className="no-record-text">{t("noRecordFound")}</div>
          </div>
        )}
      </div>
      <div className="department-pagination-list">
        {totalPages > 0 && (
          <>
            <button onClick={() => handlePrevNext("prev")} disabled={currentPage === 1} className="department-pagination-prev-list">
              <img src={LeftArrow} alt="<" />
            </button>
            {renderPagination().map((page, index) => (
              <button
                key={index}
                onClick={() => typeof page === "number" && handleClick(page)}
                disabled={page === currentPage || page.type === "ellipsis"}
                className={`department-pagination-btn-list ${page === currentPage ? "active-list" : ""} ${page.type === "ellipsis" ? "ellipse" : ""}`}
              >
                {typeof page === "number" ? page : <img src={ExtraIcon} alt="..." className="department-extra-icon" />}
              </button>
            ))}
            <button onClick={() => handlePrevNext("next")} disabled={currentPage === totalPages} className="department-pagination-next-list">
              <img src={RightArrow} alt=">" />
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default PriceList;
